import { Link } from '@remix-run/react'
import { CalendarDays } from 'lucide-react'
import { OhButton } from '~/components/ui/custom-radix-components/button'
import { RegionEmail } from '~/helpers/RegionEmail'
import { cn } from '~/lib/utils'
import SvgWrapper from '~/lib/utils/SvgWrapper'
import { useRegionConfig } from "~/store/regionConfigStore";
import { getRegionWhatsAppNumber, WHATSAPP_LINK_REL, buildWhatsAppUrl } from "~/lib/helpers/whatsAppHelper";
import { groupRegionsData } from 'custom-config/region.configs'

function ManagerCard({ managers, className }: { managers: any; className?: string }) {
  const { regionConfig } = useRegionConfig();
  const regionalWhatsApp = getRegionWhatsAppNumber(regionConfig?.region);
  const activeWhatsApp = regionalWhatsApp;
  const regionalCalendarUrl = groupRegionsData.find(gr =>
    gr.codes.includes(regionConfig?.region?.toLowerCase())
  )?.calendarUrl;

  // `/users/by-country` returns an array; some pages may pass a single object.
  const manager = Array.isArray(managers) ? managers[0] : managers;
  const photoUrl: string | undefined =
    typeof manager?.fullPhotoUrl === "string" && manager.fullPhotoUrl.trim()
      ? manager.fullPhotoUrl.trim()
      : undefined;

  return (
    <div className={cn("flex flex-col justify-between", className)}>
      <div className="mx-auto rounded-lg border p-4 shadow-custom">
        <span className="text-lg font-medium mb-2">Talk to an Expert</span>
        <hr className="mb-4" />

        <div className="flex items-center gap-4">
          {photoUrl && (
            <img
              src={photoUrl}
              alt={managers.name || "Expert Manager"}
              className="w-24 h-24 rounded-full object-cover"
            />

          )}
          <div>

            <div className='flex flex-col gap-1'>
              <span className="text-2xl">{manager?.name}</span>
              {manager?.mobilePhone && regionConfig?.country === manager?.country && (
                <div className='flex items-center gap-2'>
                  <SvgWrapper
                    urlEndPoint={process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}
                    src="/assets/icons/phone-android-outlined.svg"
                    height="20px"
                    width="20px"
                    strokeWidth="2"
                  />
                  <Link
                    to={`tel:${manager?.mobilePhone}`}
                    className='text-oh-dark-gray text-base hover:text-on-black'
                  >
                    {manager?.mobilePhone}
                  </Link>
                </div>
              )}

              {regionConfig?.phoneNumber ? (
                <div className='flex items-center gap-2'>
                  <SvgWrapper
                    urlEndPoint={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}`}
                    src={'/assets/icons/call-outlined.svg'}
                    height='20px'
                    width='20px'
                    strokeWidth='2'
                    stroke="oh-dark-gray"
                  />
                  <Link
                    to={`tel:${regionConfig?.phoneNumberWithCode}`}
                    target='_blank'
                    className='text-oh-dark-gray text-base hover:text-on-black'
                  >
                    {/* {managers?.whatsapp} */}
                    {regionConfig?.phoneNumber}
                  </Link>
                </div>

              ) :
                <RegionEmail title="Enquire now" calenderUrl={false} email={true} className="text-oh-dark-gray font-semibold text-base hover:text-on-black" />
              }

            </div>
          </div>

        </div>


        <p className="text-sm text-gray-800 mt-4">
          I’m committed to guiding you toward the perfect workspace of tomorrow. Whether you’re searching for hot desks, dedicated desks, or serviced office spaces, I’m here to support you every step of the way!
        </p>
        <div className='flex gap-4 my-4'>
          {activeWhatsApp && (
            <a
              href={buildWhatsAppUrl(activeWhatsApp)}
              target="_blank"
              rel={WHATSAPP_LINK_REL}
              className="flex-1"
            >
              <OhButton
                className="flex w-full gap-1 bg-oh-light-green text-oh-black hover:text-oh-black text-sm hover:bg-green-200"
              >
                <SvgWrapper
                  urlEndPoint={process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}
                  src="/assets/icons/whatsApp.svg"
                  height="20px"
                  width="20px"
                  fill="currentColor"
                  className="translate-y-[2px]"
                />
                WhatsApp
              </OhButton>
            </a>

          )}
          {regionalCalendarUrl && (
            <OhButton variant="outline" className="flex-1 gap-2 text-sm" asChild>
              <Link to={regionalCalendarUrl || manager?.appointmentScheduleUrl} target="_blank" rel="noreferrer">
                <CalendarDays className="h-5 w-5" />
                Book Appointment
              </Link>
            </OhButton>
          )}
        </div>
      </div>

    </div>
  )
}

export default ManagerCard